import { render, staticRenderFns } from "./QuickShare.vue?vue&type=template&id=4d80936d&scoped=true"
import script from "./QuickShare.vue?vue&type=script&lang=js"
export * from "./QuickShare.vue?vue&type=script&lang=js"
import style0 from "./QuickShare.vue?vue&type=style&index=0&id=4d80936d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80936d",
  null
  
)

export default component.exports